export default {
    entityKey: 'application-screenshots',
    // Every navigate and link in the module resolves from here, so the route
    // prefix has one definition rather than a literal at each call site (FNP-1353).
    basePath: '/application-screenshots',
    titles: {
        singular: 'Application Screenshot',
        plural: 'Application Screenshots'
    }
}
